/**
 * Contact lens — validate the chosen power-entry method and attach the result to
 * the cart line.
 *
 * Three methods, one active at a time (see snippets/contact-lens-power.liquid):
 *   list   → Right/Left Eye Power properties, injected here from the dropdowns
 *   upload → properties[Prescription file], posted by the file input itself
 *   write  → properties[Power details], posted by the textarea itself
 *
 * The upload and write fields carry their own name attributes, so they travel
 * with the form. Only the dropdown values need injecting.
 *
 * Shopify's dynamic checkout button is suppressed on these products because it
 * posts field values as text (a file arrives as C:\fakepath\name.jpg) and skips
 * this validation entirely. The Buy it now button rendered in its place routes
 * through the same add-to-cart below, then sends the customer to checkout.
 */
(function () {
  function ensurePropertyInput(form, name, value) {
    var selector = 'input[name="properties[' + name + ']"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  /* Use the visible label, not the raw value, so the cart and order read
     "No power" instead of "0.00" and keep the + sign on plus powers. */
  function selectedLabel(select) {
    var opt = select.options[select.selectedIndex];
    return opt && opt.textContent ? opt.textContent.trim() : select.value;
  }

  function removePropertyInputs(form) {
    form.querySelectorAll('input[name^="properties[Right Eye "], input[name^="properties[Left Eye "]').forEach(function (el) {
      el.remove();
    });
  }

  function showError(picker, message) {
    var el = picker.querySelector('[data-power-error]');
    if (!el) {
      alert(message);
      return;
    }
    el.textContent = message;
    el.hidden = !message;
    el.scrollIntoView({ block: 'nearest' });
  }

  function clearError(picker) {
    var el = picker.querySelector('[data-power-error]');
    if (el) el.hidden = true;
  }

  function strings(picker) {
    try { return JSON.parse(picker.dataset.strings || '{}'); } catch (err) { return {}; }
  }

  /**
   * Checks the active method and writes its values onto the form.
   * Returns false (and shows why) when the customer has not filled it in.
   */
  function prepare(picker, form) {
    var s = strings(picker);
    var method = picker.dataset.activeMethod || 'list';

    // Stale values from a method the customer switched away from
    removePropertyInputs(form);

    if (method === 'list') {
      var grid = picker.querySelector('[data-lens-row="power"]');
      if (!grid) return true;

      var eyes = ['right', 'left'];
      var fields = ['power', 'cylinder', 'axis'];
      var labels = { right: 'Right Eye', left: 'Left Eye' };
      var fieldLabels = { power: 'Power', cylinder: 'Cylinder', axis: 'Axis' };

      // Clear anything a previous attempt wrote, so switching eyes off or
      // changing method never leaves a stale value on the line item.
      removePropertyInputs(form);

      for (var e = 0; e < eyes.length; e++) {
        var eye = eyes[e];
        var powerSel = picker.querySelector('[data-lens-field="power"][data-eye="' + eye + '"]');
        if (!powerSel || !powerSel.value) {
          showError(picker, s.errorSelect);
          return false;
        }

        // Cylinder and axis describe one astigmatic correction; one without the
        // other cannot be made up, so the pair is all-or-nothing.
        var cylSel = picker.querySelector('[data-lens-field="cylinder"][data-eye="' + eye + '"]');
        var axisSel = picker.querySelector('[data-lens-field="axis"][data-eye="' + eye + '"]');
        var hasCyl = !!(cylSel && cylSel.value);
        var hasAxis = !!(axisSel && axisSel.value);
        if (cylSel && axisSel && hasCyl !== hasAxis) {
          showError(picker, s.errorCylAxis);
          return false;
        }

        for (var f = 0; f < fields.length; f++) {
          var sel = picker.querySelector('[data-lens-field="' + fields[f] + '"][data-eye="' + eye + '"]');
          if (!sel || !sel.value) continue;
          ensurePropertyInput(form, labels[eye] + ' ' + fieldLabels[fields[f]], selectedLabel(sel));
        }
      }
    } else if (method === 'upload') {
      var file = picker.querySelector('[data-power-file]');
      if (!file || !file.files || !file.files.length) {
        showError(picker, s.errorUpload);
        return false;
      }
    } else if (method === 'write') {
      var text = picker.querySelector('[data-power-text]');
      if (!text || !text.value.trim()) {
        showError(picker, s.errorWrite);
        return false;
      }
    }

    clearError(picker);
    ensurePropertyInput(form, '_product_class', 'contact-lenses');
    return true;
  }

  function checkoutUrl() {
    var cart = (window.routes && window.routes.cart_url) || '/cart';
    return cart.replace(/\/cart\/?$/, '/checkout');
  }

  function attachToForm(form) {
    if (form.dataset.contactLensCartBound) return;
    form.dataset.contactLensCartBound = 'true';

    form.addEventListener('submit', function (e) {
      var picker = document.querySelector('[data-contact-lens-power]');
      if (!picker) return;

      if (!prepare(picker, form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    var buyNow = form.querySelector('[data-lens-buy-now]') ||
                 document.querySelector('[data-lens-buy-now]');
    if (!buyNow || buyNow.dataset.bound) return;
    buyNow.dataset.bound = 'true';

    buyNow.addEventListener('click', function () {
      var picker = document.querySelector('[data-contact-lens-power]');
      if (!picker || !prepare(picker, form)) return;

      buyNow.setAttribute('aria-disabled', 'true');
      buyNow.classList.add('loading');

      // FormData carries the prescription file; no Content-Type header so the
      // browser can set the multipart boundary.
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.description || response.message || '');
          }
          window.location.href = checkoutUrl();
        })
        .catch(function (err) {
          showError(picker, err.message || '');
          buyNow.removeAttribute('aria-disabled');
          buyNow.classList.remove('loading');
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      if (document.querySelector('[data-contact-lens-power]')) {
        attachToForm(form);
      } else {
        removePropertyInputs(form);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
